import {
  contentXmlInventoryFromCrew,
  contentXmlScheduleBlocked,
  contentXmlScheduleIcaos,
  type CrewMember,
} from "@northstar/dispatch-core";

/** Synced company Dispatcher Setting + scanned Content.xml / Community ICAOs. */
export type CompanionSchedulePolicy = {
  scheduleOnlyContentXmlAirports: boolean;
  contentXmlIcaos: string[];
};

export const EMPTY_SCHEDULE_POLICY: CompanionSchedulePolicy = {
  scheduleOnlyContentXmlAirports: false,
  contentXmlIcaos: [],
};

export function companionSchedulePolicy(source: {
  company?: { scheduleOnlyContentXmlAirports?: boolean } | null;
  crew?: CrewMember[] | null;
}): CompanionSchedulePolicy {
  return {
    scheduleOnlyContentXmlAirports: source.company?.scheduleOnlyContentXmlAirports === true,
    contentXmlIcaos: contentXmlScheduleIcaos(contentXmlInventoryFromCrew(source.crew)),
  };
}

/**
 * Refuse dest/origin writes outside the scanned Content.xml list when the
 * company setting is on. Cancel and STD / load edits do not change the pair,
 * so they stay allowed.
 */
export function companionTicketWriteBlock(
  policy: CompanionSchedulePolicy | null | undefined,
  next: { originIcao?: string | null; destIcao?: string | null },
  prev?: { originIcao?: string | null; destIcao?: string | null },
): string | undefined {
  if (!policy?.scheduleOnlyContentXmlAirports) return undefined;
  const prevOrigin = (prev?.originIcao ?? "").trim().toUpperCase();
  const prevDest = (prev?.destIcao ?? "").trim().toUpperCase();
  const nextOrigin = (next.originIcao ?? prev?.originIcao ?? "").trim().toUpperCase();
  const nextDest = (next.destIcao ?? prev?.destIcao ?? "").trim().toUpperCase();
  const originChanged = next.originIcao != null && nextOrigin !== prevOrigin;
  const destChanged = next.destIcao != null && nextDest !== prevDest;
  if (!originChanged && !destChanged) return undefined;
  return contentXmlScheduleBlocked(true, policy.contentXmlIcaos, [nextOrigin, nextDest]);
}
